var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.018c-.412 0-.765-.147-1.059-.44A1.452 1.452 0 010 1.509c0-.42.147-.777.441-1.07A1.448 1.448 0 011.5 0c.412 0 .765.146 1.059.439.294.292.441.649.441 1.07 0 .42-.147.778-.441 1.07a1.448 1.448 0 01-1.059.439zm0 1.473c.412 0 .765.146 1.059.439C2.853 5.222 3 5.579 3 6c0 .421-.147.778-.441 1.07A1.448 1.448 0 011.5 7.51c-.412 0-.765-.146-1.059-.439A1.452 1.452 0 010 6c0-.421.147-.778.441-1.07A1.448 1.448 0 011.5 4.49zm0 4.491c.412 0 .765.147 1.059.44.294.291.441.648.441 1.07 0 .42-.147.777-.441 1.07A1.448 1.448 0 011.5 12c-.412 0-.765-.146-1.059-.439A1.452 1.452 0 010 10.491c0-.42.147-.778.441-1.07A1.448 1.448 0 011.5 8.982z",
    id: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.918a48e194e063a0e3a861a26ec230e3.svg";
export { ForwardRef as ReactComponent };